<template>
  <UICard class="ui-collapsible-card">
    <button
      type="button"
      class="ui-collapsible-card__header"
      :class="{ 'ui-collapsible-card__header--open': isOpen }"
      @click="handleToggle"
    >
      <span>{{ title }}</span>
      <component :is="chevronComponent" class="ui-collapsible-card__icon" />
    </button>

    <div v-if="isOpen" class="ui-collapsible-card__content">
      <slot />
    </div>
  </UICard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/24/outline'

import { UICard } from '@ui/core'

type Props = {
  title: string
  collapsed?: boolean
}

const { collapsed } = defineProps<Props>()

const isOpen = ref(!collapsed)

const chevronComponent = computed(() =>
  isOpen.value ? ChevronUpIcon : ChevronDownIcon,
)

const handleToggle = () => {
  isOpen.value = !isOpen.value
}
</script>

<style>
.ui-collapsible-card {
  @apply !p-0;

  &__header {
    @apply flex items-center justify-between;
    @apply w-full px-4 py-2;
    @apply bg-gray-50 text-gray-500;
    @apply dark:bg-gray-800 dark:text-gray-400;
    @apply rounded-md;
  }

  &__header--open {
    @apply rounded-b-none;
  }

  &__icon {
    @apply h-4 w-4;
    @apply shrink-0;
  }

  &__content {
    @apply p-4;
  }
}
</style>
